<template>
  <div>
    <pending-requests-table></pending-requests-table>
  </div>
</template>

<script>
import PendingRequestsTable from '@/components/dashboard/pending/PendingRequestsTable'
export default {
  components: {
    PendingRequestsTable
  }
};
</script>

<style scoped>
</style>
